export default __webpack_public_path__ + "static/media/My project-1 (1).4fb95943.jpg";